import { MoreHorizontal, UsersRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import type { ServiceConnectionModel } from '@/api/model'

interface Props {
  connection: ServiceConnectionModel
  onSyncEmployees: (connection: ServiceConnectionModel) => void
}

/** Actions that write beyond the connection itself stay behind a menu — never one stray click away. */
export function ServiceConnectionRowActions({ connection, onSyncEmployees }: Props) {
  const { t } = useTranslation('service-connections')

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={t('list.actions.menu')}>
          <MoreHorizontal className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onSyncEmployees(connection)}>
          <UsersRound className="mr-2 size-4" />
          {t('list.actions.syncEmployees')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
